import React from 'react';

import { ICONS } from '../../../icons';
import ProjectNameHeader from '../project-name-header/ProjectNameHeader';

function ResonanceHeader() {
  return (
    <ProjectNameHeader
      icon={ICONS.Resonance}
      defaultName='Resonance'
      selector={(state) => state.resonance.projectInfo.projectName}
    />
  );
}

export default ResonanceHeader;
